import { render, staticRenderFns } from "./Jobrecruitment.vue?vue&type=template&id=c4144ef6&"
import script from "./Jobrecruitment.vue?vue&type=script&lang=js&"
export * from "./Jobrecruitment.vue?vue&type=script&lang=js&"
import style0 from "./Jobrecruitment.vue?vue&type=style&index=0&id=c4144ef6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports